export default {
  // Filtros y configuracion de widgets (opciones de KPI)
  form_filter: 'Select a form as a filter for this report',
  forms: 'Forms',
  add_value: 'Add Values',
  ungrouped: 'Ungrouped',
  add_meta: 'Add meta',
  meta: 'Meta',
  show_value: 'Show value labels',
  color: 'Color',
  custom_scale: 'Custom colors',
  resulttype: 'Result type',
  groupby: 'Group by',
  addfilter: 'Add Filter',
  show_legend: 'Swhow legend',
  order_results: 'Order results',
  fullfillment_options: 'Fullfillment / Accomplishment',
  type: 'Type:',
  expired_soon_options: 'Units / Currency',

  // Rangos de tiempo y tendencias
  tendencias: 'Trends',
  historic_3: 'Historical (quarters)',
  historic_12: 'Historical (12 months)',
  historic_6: 'Historical (6 months)',
  historic_30: 'Historical (30 days)',
  current_month: 'Current month',
  thirty_days: 'Last 30 days',
  seven_days: 'Last 7 days',
  filter: 'Filters',
  time: 'Time',

  // Estados y mensajes genericos de widget
  load_details: 'Loading details...',
  goal: 'Goal',
  kpi: 'KPI:',
  expiration: 'expiration',
  widget_information: 'All unfiltered information is displayed (according to their roles).',
  stale_warning: 'Could not refresh. Showing the last available data',
  no_data: 'No data to display.',
  see_grafic: 'View chart',
  see_table: 'See Table',

  // Widget de ubicaciones
  ubication_top: 'Top Locations',
  no_ubication: 'No Location',

  // Widget de tareas
  total_task: 'Total tasks',
  tasks: 'Tasks',
  no_result: 'No results found',

  // Widget de sprint y autoevaluacion
  no_usersprint: 'The user is not assigned to any sprint',
  search_users: 'Find User',
  sprint: 'Sprint',
  self_assessment: 'Self-assessment',

  // Widget de reportes
  data_report: 'Content of the report',
  report: 'Report',

  // Widget de planes de accion
  create_plans: 'Action plans created',
  qualification: 'Qualification',
  advance: 'Advance',
  plan_id: 'Plan ID',
  progress: 'Progress',
  expired: 'Expiration',
  name: 'Name',
  action_plans: 'Action Plans',
  areasOfOpportunity: 'Areas of Opportunity',

  // Widget de agenda diaria
  no_events: 'No events pending for today.',
  schedule: 'Daily Agenda',

  // Widget de campañas
  campaign: 'Campaigns',

  // Mensajes de transicion del modulo
  toDate: 'We are updating this module. You can continue to consult the information in the Reports module.',
  monthbefore: 'Previous month:',

  // Gestion de dashboards (crear, seleccionar, favoritos)
  select_dashboard: 'Select a Dashboard',
  create_dashboard: 'Create Dashboard',
  new_dashboard: 'Nuevo Dashboard',
  new_dashboard_name: 'Dashboard Name:',
  favorite: 'Favourite',
  delete_dashboard_prompt: 'Do you want to delete this dashboard?',
  favorite_warning: 'Marking this dashboard as favorite will load it automatically in your home page',

  // Confirmacion de cambio de dashboard favorito (dialogo)
  labels: {
    favorite: 'Favorite Dash',
    favorite_warning: 'Your favorite dash will be changed, are you sure?'
  }
}
